import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

import { Container, Row, Col, Button, Collapse, Nav, NavItem, Tooltip } from 'reactstrap';
// import device, { size } from '../modules/mediaQuery'
// import MediaQuery from 'react-responsive';

import goback from '../../images/left-arrow-head.svg';
import infoIcon from '../../images/info-icon.svg';
import searchIcon from '../../images/search-icon.svg';
import expandIcon from '../../images/expand-arrow.svg';
import collapseIcon from '../../images/collapse-arrow.svg';
import { clearCompareInfo, clearMarketDetails, fetchMarketDetails, fetchPeriods} from '../../actions';
import RentCycleConstants from '../../constants/RentCycleConstants';
import MarketSearch from '../Common/MarketSearch';
import MarketImage from '../Common/MarketImage';
import { sectorDetails, getParams } from '../../helpers/Utils';
import GenericError from "../Common/GenericError";
import MetricConverter from '../Common/MetricConverter';

const subMarket = [{key:"submarket1", desc:"submarket1Desc"},{key:"submarket2", desc:"submarket2Desc"},{key:"submarket3", desc:"submarket3Desc"}]

export class MarketDetailMobile extends Component {
  constructor(props) {
    super(props);

      this.state = {
        show: false, // this is used to MarketCompare screen
        showRentData: true, //this is used to display Rent Data accordion
        showRentCyclePositions: true, // this is used to display Historical Rent Cycle Positions accordion
        showKeySubmarkets: true, // this is used to display Key Submarkets accordion 
        isShowSearchContainer: false,
        toolTipIndex:null,
        isOpenSource: false
      }

      this.goBack = this.goBack.bind(this); 
      this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    let { basepath, history } = this.props;
    let urlpath = (basepath)+`/marketcompareselection`;
    history.push(urlpath);

    document.querySelector('#rentcycleroot').scrollIntoView();
    }
    
  toggleSource = () => {
    this.setState({isOpenSource: !this.state.isOpenSource});
  };

  renderPopulationSource() {
    return (this.state.closeButtonVisible ? (this.props.marketCompareQuarters[0] ? "Source: " + this.props.marketCompareQuarters[0].populationSource : "Source: not provided") : (this.props.marketquarters[0] ? "Source: " + this.props.marketquarters[0].populationSource : "Source: not provided"));    
  }

  onSearchClick = (isShowSearchContainer) => {
    this.setState({
      isShowSearchContainer
    });
  }

  getMarkets() {
    let sortedMarkets = [];

    this.props.markets.forEach(element => {
      if (element.market.length > 0) {
        sortedMarkets.push(element.market);
      }
    });

    return sortedMarkets.sort();
  }

  renderAreaOnCycle()
  {
    let areaOnCycle ='';
    this.props.marketquarters.forEach(element => {
      if ((element.market) === this.props.marketselected.trim()) {
        if (element.market.length > 0) {
          areaOnCycle= element.areaOnCycle;
      }

      }
    });
    return areaOnCycle;    
  }
  renderAreaOnVacancy()
  {
    let areaOnVacancy ='';
    this.props.marketquarters.forEach(element => {
      if ((element.market) === this.props.marketselected.trim()) {
        if (element.market.length > 0) {
          areaOnVacancy= element.areaOnVacancy;
      }

      }
    });
    return areaOnVacancy;    
  }
  getCurrentPositon (){

    let latestQuarter = (this.props.periodList[this.props.periodList.length -1 ])
    let filteredLists = this.props.marketquarters.filter(function (x) {
      return x.period === latestQuarter;
    });

  return  (filteredLists[0] ? filteredLists[0].position : 0);

}
  displaySectorTextWithColor(position)
  {
    if(!position){
      position = parseInt(this.getCurrentPositon());
    } 
    else{
      position=parseInt(position);
    }
      const {sectorColor, sectorText} = sectorDetails(position);
       return <span>{sectorText}</span>
  }
  
toggleRentData=()=>{
  this.setState({showRentData: !this.state.showRentData})
}

toggleRentCyclePositions=()=>{
  this.setState({showRentCyclePositions: !this.state.showRentCyclePositions})
}

toggleKeySubmarkets=()=>{
  this.setState({showKeySubmarkets: !this.state.showKeySubmarkets})
}

handleInfoClicked = (index) => {
  this.setState((state) => ({
    toolTipIndex: state.toolTipIndex === index ? null :index
  }))
}

goBack() 
  {
  // this.props.history.goBack();
  this.props.history.push(this.props.basepath);
  }

  componentDidMount()
  {
   // this.props.fectchDetailDataMobile();
   if(this.props.periodList.length <=0)
   {
     this.props.fetchPeriods();
   }

   const selectedMarket = getParams(window.location, 'market');
   if(selectedMarket !== '')
   {    
       this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);
   }

   window.addEventListener('popstate', this.handleBackButton, false)

  }


  handleBackButton = (e) =>
{
  if(this.props.history.action === 'POP')
  {
      e.preventDefault();
    
      const search = window.location.search; 

      const params = new URLSearchParams(search);
      
      if(params.has('market') === true)
      {
        const selectedMarket = params.get('market');

        this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);

      }
  }
}

componentWillUnmount() {
  // you need to unbind the same listener that was binded.
  window.removeEventListener('popstate', this.handleBackButton, false)
}
  componentDidUpdate() {
/* 
    window.onpopstate  = (e) => {
  
        if(this.props.history.action == 'POP')
        {
          //  e.preventDefault();
          
            const search = window.location.search; 

            const params = new URLSearchParams(search);
            
            if(params.has('market') === true)
            {
              const selectedMarket = params.get('market');
 
              this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);

            }
        }
	} */


}

  findLastIndex = () => {
  const {marketquarters} = this.props;
  let i = -1
  if(marketquarters[0]){
  for (let index = 0; index < subMarket.length; index++) {
    const element = subMarket[index];
    if(marketquarters[0][element.key]){
      i = index
    }
  }}
  return i;
  }

render(){
  const {marketquarters, marketselected} = this.props;
  const lastIndex = this.findLastIndex();

    return (
    <Container className="mobile-detail-container main-container">
      <Row className="main-row">
      <Col>
        {this.state.isShowSearchContainer ?
          <MarketSearch devicetype="mobile" marketSuggestions={this.getMarkets()} searchClickHandler={this.onSearchClick} /> :     
          <div className="title market-detail">
            <img className="go-back-mobile" alt="back" src={'#{rentrackerappimages}#' +'/left-arrow-head.svg'} onClick={this.goBack}/>
            <span className="market-detail-mobile-header-text"> {RentCycleConstants.DETAIL_HEADER_TEXT} </span>
            <img className='search-icon-mobile'  alt="search-icon" src={'#{rentrackerappimages}#' +'/search-icon.svg'} onClick={() => this.onSearchClick(true)} />
          </div>
        }
      </Col>
      </Row> 
      <Row>
        <MarketImage devicetype="mobile" classes ="market-detail-img-mobile" />
      </Row>
      <Row>
      {this.props.currentError.Error ? <GenericError msg={this.props.currentError.ErrorMsg} /> :
      <>
        <Nav vertical color ="light" className="market-nav-mobile" navbar>
        <div className="mobile-detail-body">
          <NavItem className="detail-panel-title-text-mobile">
           {marketselected}
          </NavItem>
          <div className="market-section-mobile">
            <NavItem className="container-item-mobile">
              <span>
                {RentCycleConstants.POPULATION + " "}
                <img href="#" id="sourcetooltip" src={'#{rentrackerappimages}#' + '/info-icon.svg'} className="cursor-pointer ic_info_outline_24px" alt="infoIcon" />
                <Tooltip trigger="legacy" style={{textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D"}} placement="bottom-end" isOpen={this.state.isOpenSource} target="sourcetooltip" toggle={this.toggleSource}>
                  {this.renderPopulationSource()}
                </Tooltip>                
              </span>
              <span className={"nav-item-nowrap"}>
                  {marketquarters.map(x => x.population)[0]} M
              </span>
            </NavItem>
            <NavItem className="container-item-mobile">
              <span >{RentCycleConstants.OVERALL_OFFICE_MARKET_SIZE}</span>
              <span className={"nav-item-nowrap"}>
                 <MetricConverter cssclassName={"nav-item-nowrap"} officerent={marketquarters.map(x => x.overallOfficeMarketSize)[0]}/> 
              </span>
            </NavItem>
            <NavItem className="container-item-mobile no-border">
              <a className="external-link-city anchor-text-center" target="_blank" rel="noopener noreferrer" href={marketquarters.map(x => x.url)[0]}>{RentCycleConstants.LEARN_MORE_ABOUT_CBRE} {marketselected}</a>
            </NavItem>
          </div>
          <NavItem className="detail-panel-header-text-mobile ">
          {/* <div className="accordian-header-text"> */}
              {RentCycleConstants.KEY_SUBMARKETS}                
          {/* </div> */}
          {/* <div className="accordian-toggle">
            <img className="accordian-icon" alt="accordian" src={this.state.showKeySubmarkets ? collapseIcon : expandIcon} />                  
          </div> */}
          </NavItem>
          {/* <Collapse isOpen={this.state.showKeySubmarkets} style={{backgroundColor: "#F5F7F7"}}> */}
              {marketquarters[0] && subMarket.map((element, index)=> {
                return marketquarters[0][`${element.key}`] ? (
                  <NavItem className="container-item-mobile" style = {lastIndex===index ? {borderBottom:"none"}: {}} key={index}>
                  <span className="sub-market">{marketquarters[0][`${element.key}`]}</span>
                  <img  href="#"  alt="" id={`mobilesubmarket${index}tooltip`} src={'#{rentrackerappimages}#' +'/info-icon.svg'} className="ic_info_outline_24px" />
                <Tooltip  trigger="legacy" style={{textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D"}} placement="bottom-end" isOpen={this.state.toolTipIndex === index } toggle={() => this.handleInfoClicked(index)} target={`mobilesubmarket${index}tooltip`} >
                  {marketquarters[0][`${element.desc}`]}
                </Tooltip>
                </NavItem> 
                ): null
              })}
          {/* </Collapse> */}
          <NavItem className="detail-panel-header-text-mobile ">
            {/* <div className="accordian-header-text"> */}
              {/* {this.props.periodList[this.props.periodList.length -1 ]} */}
              {this.props.periodList[this.props.periodList.length -1 ]} {RentCycleConstants.OFFICE_DATA}
            {/* </div> */}
            {/* <div className="accordian-toggle">
              <img className="accordian-icon" alt="accordian" src={this.state.showRentData ? collapseIcon : expandIcon} />
            </div> */}
          </NavItem>
          {/* <Collapse isOpen={this.state.showRentData} style={{backgroundColor:'#F5F7F7'}}> */}
              <NavItem className="container-item-mobile">
                <span>{RentCycleConstants.RENT_CYCLE_POSITION}</span>
                <span className={"item-right-text positioncolor"}>{this.displaySectorTextWithColor()}</span>
              </NavItem>
              <NavItem className="container-item-mobile">
                <span>{RentCycleConstants.OVERALL_RENT_CHANGE_YOY}</span>
                <span>{marketquarters.map(x => x.overallRentChange)[0]}%</span>
              </NavItem>
          {/* </Collapse> */}
          <NavItem className="detail-panel-header-text-mobile ">
          {/* <div className="accordian-header-text"> */}
            {RentCycleConstants.HISTORICAL_RENT_CYCLE_POSITIONS}
          {/* </div> */}
          {/* <div className="accordian-toggle">
            <img className="accordian-icon" alt="accordian" src={this.state.showRentCyclePositions ? collapseIcon : expandIcon} />            
          </div>             */}
          </NavItem>
          {/* <Collapse isOpen={this.state.showRentCyclePositions} style={{backgroundColor:'#fff'}}> */}
              <div className="historical-rent-cycle-table">
              {
                marketquarters.map((obj, i)=>
                  <Row className='historical-row' key={i}>
                    <Col className="cycle-positions-col1" style={i == marketquarters.length -1 ? {border: "none"} : {}}>{marketquarters[marketquarters.length-i-1] ? marketquarters[marketquarters.length-i-1].period : ''}</Col>
                    <Col className="cycle-positions-col2" style={i == marketquarters.length -1 ? {border: "none"} : {}}>{this.displaySectorTextWithColor(marketquarters[marketquarters.length-i-1].position)}</Col>
                  </Row>                    
                )
              }
              </div>
          {/* </Collapse> */}
          </div>
          <div className="compare-button-container">
              <Button size="lg" className="mobile-comparison-button" onClick={this.onClick}>{RentCycleConstants.ADD_COMPARISON_MARKET}</Button>
          </div>
        </Nav>
      </>
      }
      </Row>
    </Container>
    )
  }
}


const mapStateToProps = (state) => {

  return {
    currentError: state.errorState,
    marketquarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [],
    marketselected: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : '',
    basepath: state.basepath,
    periodList: state.periodList,
    markets: state.markets,
    selectedWheelPosition: state.selectedWheelPosition.selectedWheelPosition,
    selectedSliderPosition : state.selected,
    activePeriod : state.activePeriod
   };
};

const mapDispatchToProps = (dispatch) => {
  return {
    
    clearCompareInfo:(clearText, clearArray, activePeriod) =>
    {
      dispatch(clearCompareInfo(clearText, clearArray))
      dispatch({ type: "FETCH_PERIODS", payload: activePeriod });
    },
    fetchMarketDetails: (actionType, selectedMarket) => {
     
       dispatch(fetchMarketDetails(actionType, selectedMarket))
     },
    clearMarketDetails: () => {
      dispatch(clearMarketDetails())
    },
    fetchPeriods: () => {
      dispatch(fetchPeriods());
     }
  }
}
  
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MarketDetailMobile)
)